export function buildIntegrationDocContext(moduleName: string) {
  return { moduleName };
}
